import React, { Fragment, useState } from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from '@mui/material/Autocomplete';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import { useHistory } from 'react-router-dom';
import artistImageUrlGenerator from 'utils/artistImageUrlGenerator';

import axios from 'axios';

const classes = {
  root: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    zIndex: 11,
    flexGrow: 1,
    minWidth: '185px',
  },
  input: {
    marginLeft: '8px',
    flex: 1,
  },
  inputBase: {
    width: '100%',
  },
  iconButton: {
    padding: '10px',
  },
  option: {
    padding: 0,
  },
};

export default function SearchBar({ initial = '' }) {
  const history = useHistory();
  const [term, setTerm] = useState(initial);
  const [results, setResults] = useState([]);
  const [timer, setTimer] = useState(null);

  const getSearchResults = async (searchTerm) => {
    const response = await axios.get(`/api/artists/search?searchterm=${searchTerm}`);
    if (response.status === 200) {
      const { data = [] } = response;
      if (data?.length) {
        return setResults(data);
      }

      setResults([
        {
          id: '___ziki_search',
          name: `Search for "${searchTerm}"`,
          pageid: searchTerm,
        },
      ]);
    }
  };

  const onInputChange = (e) => {
    const searchTerm = e.target.value;
    setTerm(e.target.value);
    clearTimeout(timer);
    if (searchTerm.length < 3) {
      const timer = setTimeout(() => {
        getSearchResults(searchTerm);
      }, 750);
      setTimer(timer);
    } else {
      getSearchResults(searchTerm);
    }
  };

  const searchSubmit = (e) => {
    e.preventDefault();
    if (term !== '') {
      setTerm('');
      history.push(`/search/${term}`);
    }
  };

  const processClick = ({ id, pageid }) => {
    if (pageid) {
      setTerm('');
      history.push(`/artist/${pageid}`);
    }
    if (id === '___ziki_search') {
      setTerm('');
      history.push(`/search/${pageid}`);
    }
  };

  return (
    <Paper component="form" sx={classes.root} onSubmit={searchSubmit}>
      <Autocomplete
        color="primary"
        size="small"
        freeSolo
        sx={classes.input}
        classes={{
          option: classes.option,
        }}
        id="search-bar"
        disableClearable
        disableListWrap
        options={results}
        placeholder="Artist search"
        ListboxComponent={List}
        onChange={(event, value) => processClick(value)}
        renderInput={(params) => (
          <InputBase
            size="small"
            ref={params.InputProps.ref}
            inputProps={params.inputProps}
            sx={classes.inputBase}
            type="search"
            placeholder="Artist search..."
            aria-label="Artist search"
            onChange={onInputChange}
            value={term}
          />
        )}
        getOptionLabel={(option) => option.name || option}
        renderOption={(props, option, { selected }) => (
          <ListItem {...props} button>
            <ListItemAvatar>
              <Avatar>
                <Box
                  component="img"
                  sx={classes.avatarImg}
                  alt=""
                  src={artistImageUrlGenerator(option.pageid, 80)}
                  height="60"
                  width="60"
                />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={option.name} />
          </ListItem>
        )}
      />
      <IconButton
        size="small"
        color="primary"
        sx={classes.iconButton}
        aria-label="Search"
        onClick={searchSubmit}
      >
        <SearchIcon />
      </IconButton>
    </Paper>
  );
}
